import { candidateRequests } from "api/candidateApi";
import React, { useState } from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormContext } from "react-hook-form";
import { ReportsCampaignSubTypeChoices } from "utils/choices";

const CandidateCampaignExamStatistic = ({ handleParamChange }) => {
  const [campaignSubTypeId, setCampaignSubTypeId] = React.useState(null);
  const [campaignId, setCampaignId] = useState(null);
  const { setValue } = useFormContext();

  const handleSubTypeChange = e => {
    setCampaignSubTypeId(e.target.value);
    setCampaignId(null);
    setValue("campaignId", null);
    setValue("campaignExamId", null);
    handleParamChange("campaignId", null);
    handleParamChange("campaignExamId", null);
  };

  const handleCampaignChange = e => {
    setCampaignId(e.target.value);
    handleParamChange("campaignId", e.target.value);
    setValue("campaignExamId", null);
    handleParamChange("campaignExamId", null);
  };

  return (
    <>
      <SelectInput
        validate={required()}
        source="campaignSubTypeId"
        label="Тип Кампания"
        choices={ReportsCampaignSubTypeChoices}
        onChange={handleSubTypeChange}
      />
      {campaignSubTypeId && (
        <ReferenceInput
          label="Кампания"
          source="campaignId"
          reference={candidateRequests.getCampaignsSelect()}
          filter={{ subType: campaignSubTypeId }}
        >
          <SelectInput
            validate={required()}
            disabled={!campaignSubTypeId}
            label="Кампания"
            optionText="nameBg"
            onChange={handleCampaignChange}
          />
        </ReferenceInput>
      )}

      {campaignId && (
        <ReferenceInput
          label="Изпит"
          source="campaignExamId"
          reference={candidateRequests.getCampaignExamsSelect()}
          filter={{ campaignId }}
        >
          <SelectInput
            validate={required()}
            optionText="exam"
            label="Изпит"
            onChange={e => handleParamChange("campaignExamId", e.target.value)}
          />
        </ReferenceInput>
      )}
    </>
  );
};

export default CandidateCampaignExamStatistic;
